import styled from "styled-components";

let Continue = styled.span` 

  color: ${global.config.colors.primaryText} !important;

  background-image: ${`linear-gradient(to top, ${global.config.colors.primary}, ${global.config.colors.primaryLight}) !important`} };

`;

export default Continue